import { ReactElement } from 'react';
import { CartesianData } from '../ChartWidgetViewer';
import { AreaChartWidgetConfiguration, LineType } from '@methodset/application-client-ts';
import { ApexChartUtils } from '../ApexChartsUtils';
import ReactApexChart from 'react-apexcharts';
import classNames from 'classnames';
import './AreaChartView.less';

export type AreaChartProps = {
    className?: string,
    data: CartesianData,
    configuration: AreaChartWidgetConfiguration
};

export const AreaChartView = (props: AreaChartProps): ReactElement => {

    const series = (): ApexAxisChartSeries => {
        return props.data.seriesList;
    }

    const options = (): ApexCharts.ApexOptions => {
        const options = ApexChartUtils.cartesianOptions("area", props.data, props.configuration);
        options.stroke = ApexChartUtils.strokeOptions();
        options.grid = ApexChartUtils.gridOptions();
        options.chart!.stacked = !!props.configuration.isStacked;
        const lineType = LineType.option(props.configuration.lineType);
        if (lineType) {
            options.stroke!.curve = lineType as any
        }
        return options;
    }

    return (
        <div className={classNames('x-areachartview', props.className)}>
            <ReactApexChart
                options={options()}
                series={series()}
                type="area"
                height={props.configuration.height}
            />
        </div>
    )
}
